interface DeviceInfo {
    deviceName: string;
    ip: string;
    macAddress: string;
}

export class DeviceService {

    private static async getDeviceInfo(): Promise<DeviceInfo> {
        let deviceInfo: DeviceInfo = {
            deviceName: 'Unknown',
            ip: 'Unknown',
            macAddress: 'Unknown'
        };


        if (window.electronAPI?.device) {
            try {
                const result = await window.electronAPI.device.getInfo();
                if (result.success && result.data) {
                    deviceInfo = result.data;
                }
            } catch (error) {
                console.warn('Could not get device info from Electron:', error);
            }
        }

        return deviceInfo;
    }

    static async registerDevice(): Promise<{ success: boolean; deviceId?: string; error?: string }> {
        try {
            const deviceInfo = await this.getDeviceInfo();

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/Device/insert`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        deviceName: deviceInfo.deviceName,
                        ip: deviceInfo.ip,
                        macAddress: deviceInfo.macAddress,
                    }),
                }
            );

            if (response.ok) {
                const json = await response.json();

                const deviceId = json.deviceId;
                localStorage.setItem("deviceId", deviceId); 

                console.log('Device registered successfully with ID:', deviceId);

                return { success: true, deviceId };
            } else {
                const errorText = await response.text();
                console.error('Device registration failed:', response.status, errorText);
                return { success: false, error: `${response.status}: ${errorText}` };
            }

        } catch (error: any) {
            console.error('Error registering device:', error);
            return { success: false, error: error.message };
        }
    }

    static async unregisterDevice(): Promise<{ success: boolean; error?: string }> {
        try {
            const deviceId = localStorage.getItem("deviceId");

            if (!deviceId) {
                console.warn("⚠️ No deviceId found in localStorage — nothing to unregister");
                return { success: true };
            }

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/Device/delete/${deviceId}`,
                {
                    method: 'POST',
                    credentials: 'include',
                }
            );

            if (response.ok) {
                console.log('Device unregistered successfully');
                return { success: true };
            } else {
                const errorText = await response.text();
                console.error('Device unregistration failed:', errorText);
                return { success: false, error: errorText };
            }

        } catch (error: any) {
            console.error('Error unregistering device:', error);
            return { success: false, error: error.message };
        }
    }
}
